var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CheckmarkStandAlone } from '../../assets/images/global/checkmark-stand-alone.svg';
import { ReactComponent as Repeat } from '../../assets/images/global/repeat.svg';
import SecurityAlertCardAPI from './selected-pending-exams-card-api';
import './selected-pending-exams-card.css';
import moment from 'moment';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let SelectedPendingExamsCard = class SelectedPendingExamsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            const { cardKey, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({ value: { cardKey } }));
            }
        };
        this.handleResetClick = () => {
            const { cardKey, onResetClick } = this.props;
            if (isFunction(onResetClick)) {
                onResetClick(new ClickEvent({ value: { cardKey } }));
            }
        };
        this.renderDivisor = (index) => {
            if (index > 0) {
                return (React.createElement("div", { className: 'c-selected-pending-exams-card__container-risk' },
                    React.createElement("div", { className: 'c-selected-pending-exams-card__risk' })));
            }
            return null;
        };
    }
    renderDescriptionName() {
        return (React.createElement("div", { className: 'c-selected-pending-exams-card__description-name' },
            React.createElement(CheckmarkStandAlone, { className: 'c-selected-pending-exams-card__checkmark-icon' }),
            React.createElement("span", { className: 'c-selected-pending-exams-card__description-name-text' }, this.props.title)));
    }
    renderContent(exam, index) {
        const dtStr = exam.dtPrevExecucaoTimestamp;
        const shortDateFormat = moment().localeData().longDateFormat('L');
        const shortHourFormat = moment().localeData().longDateFormat('LT');
        const shortDate = moment(dtStr).format(shortDateFormat);
        const shortHour = moment(dtStr).format(shortHourFormat);
        return (React.createElement("div", { key: index },
            this.renderDivisor(index),
            React.createElement("div", { className: 'c-selected-pending-exams-card__content' },
                React.createElement("div", { className: 'c-selected-pending-exams-card__content-left' },
                    React.createElement("div", { className: 'c-selected-pending-exams-card__content-left-up' },
                        React.createElement("span", { className: 'c-selected-pending-exams-card__content-left-up-title' }, MessageService.translate('label.exam-types')),
                        React.createElement("span", { className: 'c-selected-pending-exams-card__content-left-up-text' }, exam.nmExame)),
                    this.renderObservation(exam),
                    this.renderStatus(exam)),
                React.createElement("div", { className: 'c-selected-pending-exams-card__content-right' },
                    React.createElement("span", { className: 'c-selected-pending-exams-card__content-right-title' }, MessageService.translate('label.infusion-viewer.date')),
                    React.createElement("span", { className: 'c-selected-pending-exams-card__content-right-text' }, shortDate),
                    React.createElement("span", { className: 'c-selected-pending-exams-card__content-right-text' }, shortHour)))));
    }
    renderStatus(exam) {
        if (!exam.ieStatusAtend) {
            return null;
        }
        const statusDescription = exam.statusDescription || this.translateStatus(exam);
        return (React.createElement("div", { className: 'c-selected-pending-exams-card__content-left-down' },
            React.createElement("span", { className: 'c-selected-pending-exams-card__content-left-down-title' }, MessageService.translate('tws.txt-status')),
            React.createElement("span", { className: 'c-selected-pending-exams-card__content-left-down-text' }, statusDescription)));
    }
    translateStatus(exam) {
        switch (exam.ieStatusAtend) {
            case 11:
            case 12:
                return MessageService.translate('tws.txt-recollect');
            case 10:
                return MessageService.translate('tws.txt-waiting-collect');
            case 20:
                return MessageService.translate('tws.txt-send-collect');
            case 16:
                return MessageService.translate('tws.txt-waiting-send');
            default:
                break;
        }
        throw new Error('Method not implemented.');
    }
    renderObservation(exam) {
        if (!exam.dsObservacao) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("div", { className: 'c-selected-pending-exams-card__content-left-down' },
            React.createElement("span", { className: 'c-selected-pending-exams-card__content-left-down-title' }, MessageService.translate('label.selected-pending-exams.observation')),
            React.createElement("span", { className: 'c-selected-pending-exams-card__content-left-down-text' }, exam.dsObservacao)));
    }
    renderResetButton() {
        return (React.createElement("div", { className: 'c-selected-pending-exams-card__reset-button', onClick: this.handleResetClick },
            React.createElement(Repeat, { className: 'c-selected-pending-exams-card__repeat-icon' }),
            React.createElement("div", { className: 'c-selected-pending-exams-card__reset-button-text' }, MessageService.translate('label.selected-pending-exams.undo'))));
    }
    renderField() {
        const exams = this.props.exams;
        return (React.createElement("div", { className: 'c-selected-pending-exams-card__container' },
            this.renderDescriptionName(),
            exams && exams.map((exam, index) => this.renderContent(exam, index)),
            this.renderResetButton()));
    }
    render() {
        const { cardKey } = this.props;
        return (React.createElement(Card, { className: 'c-selected-pending-exams-card c-hidden-tap', onClick: () => this.handleClick(), selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: cardKey, width: 12 }, this.renderField()));
    }
};
SelectedPendingExamsCard = __decorate([
    AwesomeComponent({ api: SecurityAlertCardAPI, type: ComponentType.DATA_DISPLAY })
], SelectedPendingExamsCard);
export default SelectedPendingExamsCard;
//# sourceMappingURL=selected-pending-exams-card.js.map